import { Link } from 'react-router-dom';

export default function HeaderLogo({ isSolid }) {
  return (
    <Link
      to="/"
      className="flex items-center shrink-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-mcx-signal rounded-sm"
      data-testid="header-logo"
      aria-label="MobileCoreX home"
    >
      <img
        src={isSolid ? '/mcx-logo-full-240.png' : '/mcx-logo-full-white-240.png'}
        alt="MobileCoreX"
        className="h-7 md:h-8 w-auto object-contain"
      />
    </Link>
  );
}
